import React from 'react';
import type LinkOpsgeniePageType from '@atlassian/jira-spa-apps-project-settings-link-opsgenie-v2/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyLinkOpsgeniePage = lazyForPaint<typeof LinkOpsgeniePageType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-link-opsgenie-v2", jiraSpaEntry: "async-project-settings-link-opsgenie-v2" */ '@atlassian/jira-spa-apps-project-settings-link-opsgenie-v2'
		),
);

const AsyncLinkOpsgeniePage = (): React.JSX.Element => (
	<LazyPage Page={LazyLinkOpsgeniePage} pageId="link-opsgenie-page" shouldShowSpinner={false} />
);

export default AsyncLinkOpsgeniePage;
